import React from 'react';
import type { OnboardingSummary } from '../../../types/onboarding';
import useOnboardingSummary from '../../../hooks/useOnboardingSummary';

interface ExtraSectionProps {
  section: OnboardingSummary;
}

const ExtraSection = (props: ExtraSectionProps) => {
  const { section } = props;

  const { extraInfo } = useOnboardingSummary({ section });

  return (
    <div>
      <p className='text-lg mb-0'>{extraInfo}</p>
    </div>
  );
};

export default ExtraSection;
